//Заменить при полном переезде на swagger-generator
import { IOfferSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

import { FOfferType, getOfferType } from '../../utils/offer_type';

export function checkShouldSendAdsEventForFlatOffer(offer: IOfferSchema) {
  const offerType = getOfferType(offer);

  return [FOfferType.Flat, FOfferType.FlatNew, FOfferType.FlatOld].includes(offerType);
}
